<template>
  <cc-container class="return-list">
    <!-- <cc-header-nav title="退款管理" url="/user/index?goback=1"> -->
    <cc-header-nav title="退款管理" url="/#/management">
      <cc-svg-icon @click="showDatePicker" size="20px" slot="right" icon-class="calendar"></cc-svg-icon>
    </cc-header-nav>
    <cc-fade>
      <div style="position:relative;">
        <cc-date-filter
          v-show="dateFilterVisible"
          @search="handleDateFilter"
          @cancel="emptyData"
          ref="dateFilter"
        ></cc-date-filter>
      </div>
    </cc-fade>
    <div class="search-box" style="border-bottom:5px solid #eeeeee;">
      <input
        v-model="return_number"
        class="input-search"
        type="text"
        placeholder="退款单搜索"
        @keyup.13="search()"
      />
      <cc-svg-icon
        size=".16rem"
        @click="return_number=''"
        class-name="search-icon"
        :icon-class="iconVisible?'cancel':'search'"
      ></cc-svg-icon>
    </div>
    <cc-main id="container">
      <van-tabs @click="handleTabClick" color="#1BB0D9" v-model="active" :line-height="1">
        <van-tab title="全部退款"></van-tab>
        <van-tab title="待审核"></van-tab>
        <van-tab title="已完成"></van-tab>
        <van-tab title="已失效"></van-tab>
      </van-tabs>
      <van-list
        class="return-list"
        v-model="m_loading"
        :finished="m_finished"
        :finished-text="m_finishedText"
        :immediate-check="m_immediateCheck"
        @load="mHandlePullUpLoadMore"
      >
        <cc-not-order v-if="list.length === 0 && m_loading === false" tip="亲，暂无相关退款单哦"></cc-not-order>
        <cc-animation-list>
          <section class="return-item" v-for="item in list" :key="item.id">
            <div class="return-top">
              <p>退款单号：{{item.refund_number}}</p>
              <p style="color: #1BB0D9;">{{item.state | getRefundState}}</p>
            </div>
            <div class="return-middle">
              <div class="middle-item">
                <p>退款类型：{{item.from_return_id == '0' ? '仅退款' : '退货退款'}}</p>
                <p>退款原因：{{item.reason}}</p>
              </div>

              <div class="middle-item">
                <p>退款说明：{{item.message}}</p>
                <p>
                  退款金额：
                  <span class="price">￥{{item.price}}</span>
                </p>
              </div>

              <div class="middle-item">
                <p>申请时间：{{item.created_time}}</p>
              </div>
              <div class="middle-item" v-if="item.state === '3'">
                <p>作废原因：{{item.remarks}}</p>
              </div>
            </div>
            <div class="return-bottom">
              <p>
                来源单据：
                <span style="color: #1BB0D9;" @click="to(item)">{{item.from_number}}</span>
              </p>
              <p>
                <van-button
                  v-if="item.state === '0'"
                  style="background: #1BB0D9;border-color: #1BB0D9;height: 24px;line-height: 22px;"
                  size="small"
                  type="primary"
                  @click.stop="cancel(item)"
                >取消退款申请</van-button>
                <cc-svg-icon
                  class="pr10"
                  icon-class="delete"
                  @click.stop="del(item)"
                  v-if="['1', '3'].includes(item.state)"
                ></cc-svg-icon>
              </p>
            </div>
          </section>
        </cc-animation-list>
      </van-list>
    </cc-main>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { Lazyload, List, Tab, Tabs, Dialog, Toast, Button } from 'vant'

import { types } from '../../../../store/modules/order'

import ListMixin from '@/mixins/list'
Vue.use(Lazyload)
  .use(List)
  .use(Tab)
  .use(Tabs)
  .use(Dialog)
  .use(Toast)
  .use(Button)
export default {
  name: 'return-list',
  mixins: [ListMixin],
  components: {},
  data () {
    return {
      // 搜索清除图标的显示隐藏
      iconVisible: false,
      start_time: null,
      end_time: null,
      list: [],
      // 搜索框
      return_number: '',
      // 默认选择第一个 Tab
      active: 0,
      // 状态
      state: -1,
      dateFilterVisible: false
    }
  },
  filters: {
    /**
     * @description 获取退货单状态
     */
    getRefundState (type) {
      var state = {
        0: '待审核',
        1: '已取消',
        2: '已完成',
        3: '已作废'
      }
      return state[type]
    }
  },
  computed: {
    ...mapGetters(['getRefundList', 'deleteRefund', 'offRefund'])
  },
  watch: {
    return_number () {
      this.return_number.length > 0
        ? (this.iconVisible = true)
        : (this.iconVisible = false)
    }
  },
  created () {
    this.m_page.limit = 5
    this.loadData()
  },
  methods: {
    ...mapActions([
      types.GET_REFUND_LIST,
      types.DELETE_REFUND,
      types.OFF_REFUND
    ]),
    handleDateFilter ({ startDate, endDate }) {
      this.start_time = startDate
      this.end_time = endDate
      this.search()
      this.dateFilterVisible = false
    },
    showDatePicker () {
      this.dateFilterVisible = ~this.dateFilterVisible
    },
    emptyData ({ startDate, endDate }) {
      // 父组件改变子组件的值
      this.$refs.dateFilter.startDate = ''
      this.$refs.dateFilter.endDate = ''
    },
    search () {
      this.mReset()
      const reset = true
      this.loadData(reset)
    },
    async handleTabClick (index, title) {
      const stateMap = {
        全部退款: -1,
        待审核: 0,
        已完成: 2,
        已失效: 3
      }
      // Toast.loading({
      //   message: '正在加载中'
      // })
      this.state = stateMap[title]
      const reset = true
      this.mReset()
      await this.loadData(reset)
      // Toast.clear()
    },
    async loadData (reset) {
      if (reset) {
        this.list = []
      }
      this.mRequest()
      await this.GET_REFUND_LIST({
        page: this.m_page.curr,
        limit: this.m_page.limit,
        refund_number: this.return_number,
        start_time: this.start_time,
        end_time: this.end_time,
        state: this.state
      })
      this.$tips(this.getRefundList, data => {
        if (data.return_data.length === 0) {
          this.mEnd()
          if (this.list.length === 0) {
            this.m_finishedText = ''
          }
        } else {
          this.list = [...this.list, ...data.return_data]
          if (data.return_data.length < 10) {
            this.m_finishedText = '已全部加载完成'
            this.mEnd()
          }
        }
      })
      this.mSuccess()
    },
    /**
     * @description 删除退款记录
     */
    del (item) {
      Dialog.confirm({
        title: '提示',
        message: '你确定要删除退款申请吗？'
      })
        .then(async val => {
          await this.DELETE_REFUND({
            id: item.id
          })
          this.$tips(this.deleteRefund, () => {
            item.state = '1'
          })
          this.$tips(
            this.deleteRefund,
            {
              tip: true
            },
            () => {
              this.list.splice(this.list.findIndex(i => i.id === item.id), 1)
            }
          )
        })
        // .catch(err => {
        .catch(() => {
          // console.log(err)
        })
    },
    /**
     * @description 取消退款申请
     */
    cancel (item) {
      Dialog.confirm({
        title: '提示',
        message: '你确定要取消退款申请吗？'
      })
        .then(async () => {
          await this.OFF_REFUND({
            id: item.id
          })
          this.$tips(this.offRefund, () => {
            item.state = '1'
          })
        })
        // .catch(err => {
        .catch(() => {
        })
    },
    /**
     * @description 跳转页面
     */
    to (item) {
      // 退货退款
      if (item.from_return_id !== '0') {
        this.$router.push({
          path: `/order/return/${item.from_return_id}`,
          query: {
            refund: 1
          }
        })
      } else {
        // 仅退款
        this.$router.push({
          path: `/order/refund/${item.id}`,
          query: {
            order_number: item.from_number
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/index.scss";
.return-list {
  background: #fff;
  .price {
    color: $price-color;
    font-size: 14px;
    line-height: 1;
  }
  .search-box {
    height: 40px;
    position: relative;
    @include center(column);
    .input-search {
      height: 28px;
      width: 91%;
      border-radius: 2px;
      border: 1px solid $border-color-base;
      padding-left: 10px;
      font-size: 12px;
    }
    .search-icon {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: 20px;
    }
  }
  .return {
    &-list {
      @include flex(column);
    }
    &-item {
      box-sizing: border-box;
      padding: 10px;
      border: 1px solid $border-color-base;
      border-left: 0;
      border-right: 0;
      box-shadow: $box-shadow-base;
      margin-bottom: 8px;
    }
    &-top {
      @include flex(row);
      padding-bottom: 12px;
      border-bottom: 1px solid $border-color-base;
      justify-content: space-between;
      font-size: 12px;
      color: $heading-color;
      font-weight: 700;
      .price {
        color: #eb1f1f;
        font-weight: 700;
      }
    }
    &-middle {
      padding: 15px 0;
      border-bottom: 1px solid $border-color-base;
      align-items: center;
      .middle-item {
        @include flex(row);
        > p {
          width: 50%;
          @include ell();
        }
        margin-bottom: 15px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    &-bottom {
      padding-top: 10px;
      font-size: 11px;
      @include ell();
      @include flex(row);
      justify-content: space-between;
      align-items: center;
    }
    &-img {
      width: 60px;
      height: 60px;
      border: 1px solid $border-color-base;
      margin-right: 25px;
      &-list {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
.van-tabs__line {
  bottom: 20px;
}
</style>
